import { isTestMode } from "./testMode";

const LEGACY_API_BASE = "https://theofast-api.167-71-47-159.sslip.io";
const PRODUCTION_API_BASE = "https://fwdmailer.com";

export function resolveApiBase(configuredBase, hostname = window.location.hostname) {
  const configured = String(configuredBase || "").trim();
  if (configured) {
    const normalized = configured.replace(/\/$/, "");
    return normalized === LEGACY_API_BASE ? PRODUCTION_API_BASE : normalized;
  }
  return ["localhost", "127.0.0.1"].includes(hostname) ? "" : PRODUCTION_API_BASE;
}

const API_BASE = resolveApiBase(process.env.REACT_APP_API_BASE_URL);

export class ApiError extends Error {
  constructor(message, code, status) {
    super(message);
    this.code = code;
    this.status = status;
  }
}

export async function apiRequest(path, options = {}) {
  const testRequest = isTestMode() && options.method === "POST"
    && (path === "/api/theofast/videos/analyze" || path.startsWith("/api/theofast/events/"));
  const requestOptions = testRequest
    ? { ...options, body: JSON.stringify({ ...JSON.parse(options.body || "{}"), testMode: true }) }
    : options;
  let response;
  try {
    response = await fetch(`${API_BASE}${path}`, {
      ...requestOptions,
      headers: { "Content-Type": "application/json", ...(options.headers || {}) },
    });
  } catch (_error) {
    throw new ApiError("Couldn’t reach TheoFast’s server. Your network may be blocking the connection. Try another network or retry shortly.", "NETWORK_UNAVAILABLE", 0);
  }
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    throw new ApiError(body?.error?.message || "TheoFast could not complete this request. Try again shortly.", body?.error?.code, response.status);
  }
  if (!body) throw new ApiError("TheoFast’s server returned an unexpected response. Please try again.", "INVALID_API_RESPONSE", response.status);
  return body;
}
